// extracted by mini-css-extract-plugin
export default {"accountHeader":"Ek-z","newDesignAccountHeader":"Fk-z","primeBadge":"Gk-z","logout":"Hk-z"};